(function () {
  // Presentation only: preserve the approved label after Dawn updates availability.
  // Product, variant, selling-plan, price and checkout state remain owned by the recovered components.
  function syncLabels(root) {
    root.querySelectorAll('[data-hg-submit-label]').forEach(button => {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const label = button.querySelector('span');
      if (label && label.textContent !== button.dataset.hgSubmitLabel) label.textContent = button.dataset.hgSubmitLabel;
    });
  }
  if (typeof module !== 'undefined') module.exports = { syncLabels };
  if (typeof document === 'undefined') return;
  function connect(root) {
    if (root.dataset.hgLabelObserved) return;
    root.dataset.hgLabelObserved = 'true';
    const observer = new MutationObserver(() => syncLabels(root));
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    syncLabels(root);
  }
  document.querySelectorAll('.hg-fgp-purchase').forEach(connect);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('.hg-fgp-purchase')) connect(event.target);
    event.target.querySelectorAll('.hg-fgp-purchase').forEach(connect);
  });
})();
